import { Diamond } from '@gonfalon/icons/Diamond';
import type { IconProps } from '@launchpad-ui/icons';

import { getVariationFillColor } from '../../utils/getVariationFillColor';

export type VariationColorProps = {
  variationIndex: number;
  className?: string;
  size?: IconProps['size'];
  overrideColor?: string;
};

export function VariationColor({ variationIndex, className, size = 'small', overrideColor }: VariationColorProps) {
  // TODO: once flags are also switched over to using the new color setup, we should rename this to VariationIcon
  // so that we have a single component to swap the icon if we want.
  return <Diamond className={className} size={size} fill={overrideColor ?? getVariationFillColor(variationIndex)} />;
}
